import { useNavigate } from 'react-router-dom';
import { ProfilePage, mapMeToProfileData } from '@practium/features/profile';
import { useGetMe } from '@practium/features/api';

export const ProfilePageAdmin = () => {
	const navigate = useNavigate();
	const { data: me, isLoading } = useGetMe();

	const handleModify = () => {
		navigate('/perfil/editar');
	};

	return (
		<ProfilePage
			data={me ? mapMeToProfileData(me) : null}
			isLoading={isLoading}
			onModify={handleModify}
		/>
	);
};
